export const TIME_WINDOW_DEFAULT = "last-7-days";
export const TIME_WINDOW_ALL_TIME = "all-time";
export type TimeWindowAllTimeToken = typeof TIME_WINDOW_ALL_TIME;

export const SIZE = 220;
export const ALL_TIME_LABEL = "All time";
export const ALL_TIME_MIN_YEARS = 10;
export const PRESET_PREFIX = "Last ";
export const DATE_FORMAT = "MMM d, yyyy";
export const SHORT_DATE_FORMAT = "MMM d";
export const LOCALE = "en-CA";
export const HISTORY_LIMIT = 6;

export const URL_DATE_DELIMITERS = {
  DATE_DELIMITER: "-",
  TIME_DELIMITER: "_",
  RANGE_DELIMITER: "~~",
  FULL_TIME_DELIMITER: ".",
} as const;

export const NO_DATA_POPOVER_TIMEOUT_MS = 1000;
export const NO_DATA_POPOVER_HIDE_TIMEOUT_MS = 5000;
